/** 백엔드 `PasswordConstraintValidator`와 동일 (영문·숫자·특수문자 포함 8자 이상) */
export const PORTAL_PASSWORD_REGEX =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+=\-{}|:;"'<>,.?/~`]).{8,}$/;

export const PASSWORD_POLICY_MESSAGE =
  '비밀번호는 영문, 숫자, 특수문자를 포함한 8자 이상이어야 합니다.';

/** 입력란 placeholder용 짧은 안내 */
export const PASSWORD_POLICY_PLACEHOLDER = '8자 이상, 영문·숫자·특수문자 포함';

export function getPasswordPolicyMessage(t) {
  return t('mypage.myInfo.password.policyMessage');
}

export function getPasswordPolicyPlaceholder(t) {
  return t('mypage.myInfo.password.policyPlaceholder');
}

export function isValidPortalPassword(password) {
  if (password == null || String(password).trim() === '') return false;
  return PORTAL_PASSWORD_REGEX.test(String(password));
}
